import * as React from "react";
import { useTranslation } from "react-i18next";
import SectionComponent from "components/common/Section/SectionComponent";
import TeamsCollection from "collections/components/TeamCollections";
import { COLLECTIONS_ENABLED } from "collections/constants";
const CollectionsSection = ({ team }) => {
  const { t } = useTranslation("enterprise_security");
  if (COLLECTIONS_ENABLED)
    return /* @__PURE__ */ React.createElement(SectionComponent, { title: t("team_details_collections.title") }, /* @__PURE__ */ React.createElement(TeamsCollection, { teamId: team.id }));
  return null;
};
export default CollectionsSection;
